import { z } from 'zod';
import { defineEndpoint } from '../define';
import {
  CommitShaSchema,
  ReleaseEnvironmentSchema,
  VersionStringSchema,
} from '../release-products/shapes';
import {
  ReleaseDetailSchema,
  SelectedWorkflowsSchema,
  WorkflowInputOverridesSchema,
} from './shapes';

export const CreateReleaseDraftBodySchema = z.object({
  productId: z.string().uuid(),
  environment: ReleaseEnvironmentSchema,
  version: VersionStringSchema,
  description: z.string().trim().max(255).default(''),
  ref: z.string().trim().max(200).default(''),
  commitSha: z.union([CommitShaSchema, z.literal('')]).default(''),
  selectedWorkflows: SelectedWorkflowsSchema.default([]),
  workflowInputOverrides: WorkflowInputOverridesSchema.default({}),
  baseReleaseId: z.string().uuid().optional(),
});
// Input type: the defaulted fields (ref, workflows, …) stay optional for callers.
export type CreateReleaseDraftBody = z.input<typeof CreateReleaseDraftBodySchema>;

export const createReleaseDraft = defineEndpoint({
  method: 'POST',
  path: '/v1/releases',
  params: z.object({}),
  query: z.object({}),
  body: CreateReleaseDraftBodySchema,
  response: z.object({ data: ReleaseDetailSchema }),
  successStatus: 201,
});
